import type { FC } from 'react'
import React, { memo } from 'react'
import classNames from 'classnames'
import type { IPageLoaderProps } from './interfaces'
import './styles.scss'

const PageLoader: FC<IPageLoaderProps> = ({ className }) => <div className={classNames('page-loader', className)} />

export default memo(PageLoader)
